import{getDefaultExportFromCjs as r}from"../../_virtual/_commonjsHelpers.js";import{__module as o}from"../../_virtual/index4.js";import{f as s}from"./factoryWithThrowingShims.js";o.exports=s();var t=r(o.exports);export{t as default};
//# sourceMappingURL=index.js.map
